define.alias("shared/components/shared/modal/header", "calendar/components/shared/modal/header");